import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PageLayout from '@/components/ui/page-layout'
import { Button } from '@/components/ui/button'
import PlanDetails from '@/features/plans/components/PlanDetails'

export default function PlanDetailsRoute() {
    const { id = '' } = useParams()
    const navigate = useNavigate()
    return (
        <PageLayout
            title='Plan Details'
            subtitle={id ? `Plan ID: ${id}` : undefined}
            breadcrumbs={[{ label: 'Plans', href: '/plans' }, { label: 'Details' }]}
            action={id ? (
                <Button onClick={() => navigate(`/plans/edit/${id}`)}>Edit</Button>
            ) : undefined}
        >
            <PlanDetails />
        </PageLayout>
    )
}


